import {AfterViewInit, Component, ElementRef, HostListener} from '@angular/core';
import {SCREEN_SIZE} from '../../models/screen-size.enum';
import {ResizeService} from '../../services/resize/resize.service';

@Component({
    selector: 'app-size-detector',
    templateUrl: './size-detector.component.html',
    styleUrls: ['./size-detector.component.scss'],
    standalone: false
})
export class SizeDetectorComponent implements AfterViewInit {

  constructor(private elementRef: ElementRef, private resizeSvc: ResizeService) {
  }

  prefix = 'is-';
  sizes = [
    {
      id: SCREEN_SIZE.XS, name: 'xs', css: `d-block d-sm-none`
    },
    {
      id: SCREEN_SIZE.SM, name: 'sm', css: `d-none d-sm-block d-md-none`
    },
    {
      id: SCREEN_SIZE.MD, name: 'md', css: `d-none d-md-block d-lg-none`
    },
    {
      id: SCREEN_SIZE.LG, name: 'lg', css: `d-none d-lg-block d-xl-none`
    },
    {
      id: SCREEN_SIZE.XL, name: 'xl', css: `d-none d-xl-block`
    },
  ];

  @HostListener('window:resize', [])
  onResize(): void {
    this.detectScreenSize();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.detectScreenSize(), 2200);
  }

  private detectScreenSize(): void {
    const currentSize = this.sizes.find(x => {
      // get the HTML element
      const el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);

      // check its display property value
      return window.getComputedStyle(el).display !== 'none';
    });
    this.resizeSvc.onResize(currentSize.id);
  }

}
